import React from "react";
import AdminEditCity from "../../Components/Admin/AdminEditCity";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditCityPage = ()=>{
    return (
      <AdminEditCity />
    )
}

export default AdminEditCityPage;